import { useState } from "react";
import { ComponentProps } from "../registry";
import { useBound, writePath } from "../helpers";
import { dispatchAction } from "../../action";
import { ActionDescriptor, BoundList, BoundValue } from "../../types";

interface FileEntry { name: string; size: number; type: string }

export function FileUpload({ fields, scope }: ComponentProps) {
  const label = useBound<string>(fields.label as BoundValue, scope) ?? "Drop files here or click to browse";
  const accept = useBound<string>(fields.accept as BoundValue, scope);
  const multiple = useBound<boolean>(fields.multiple as BoundValue, scope) ?? false;
  const filesPath = (fields.files as BoundList | undefined)?.path;
  const upload = fields.uploadAction as ActionDescriptor | undefined;
  const [dragOver, setDragOver] = useState(false);

  const onFiles = async (files: FileList | null) => {
    if (!files) return;
    const list: FileEntry[] = Array.from(files).map((f) => ({
      name: f.name, size: f.size, type: f.type,
    }));
    if (filesPath) writePath(filesPath, list);
    if (upload) await dispatchAction(upload, scope);
  };

  return (
    <label
      className={`a2-fileupload${dragOver ? " over" : ""}`}
      onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault(); setDragOver(false);
        onFiles(e.dataTransfer.files);
      }}
    >
      <input
        type="file"
        accept={accept ?? undefined}
        multiple={multiple}
        onChange={(e) => onFiles(e.target.files)}
      />
      <span>{label}</span>
    </label>
  );
}
